import AgyleAccordion from '../../../../components/ui/accordion/agyleAccordion';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';

const AssessmentListInPatientBox = (props) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState(true);

    return (
        <AgyleAccordion
            expanded={expanded}
            label={t(props?.assessment?.specGroup?.__description)}
            onChange={() => setExpanded(!expanded)}
            formBackground
        >
            {props.children}
        </AgyleAccordion>
    );
};

export default AssessmentListInPatientBox;